export const get_data = (key) => {
  return window.localStorage.getItem(key);
};

export const set_data = (key, data) => {
  window.localStorage.setItem(key, data);
};

export const clear_data = (key) => {
  window.localStorage.removeItem(key);
};

export default { get_data, set_data, clear_data };
